import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { OFFER_INCLUDES, BONOS } from './salesData';
import { BUNDLE_IMAGE_URL } from '../utils/headMeta';
export function OfferSection() {
  return <section id="comprar" className="bg-sand py-12 sm:py-16" data-id="element-154" data-mp="df6sc3ie4vha">
      <div className="mx-auto max-w-5xl px-5" data-id="element-155" data-mp="id89uk064mqn">
        <div className="text-center" data-id="element-156" data-mp="icgixmhind6p">
          <SectionTag className="bg-white" data-id="element-157" data-mp="ifkux6183d7x">Todo lo que recibís</SectionTag>
          <h2 className="mx-auto mt-3.5 max-w-[20ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[28ch] sm:text-[2.3rem]" data-id="element-158" data-mp="md0dqjema4po">
            Todo el sistema, en un <span className="text-gold" data-id="element-159" data-mp="wc80tyb5ldpz">solo pago</span>.
          </h2>
        </div>

        <div className="mt-7 overflow-hidden rounded-[2rem] border border-stone bg-white shadow-[0_40px_80px_-50px_rgba(56,37,34,0.6)]" data-id="element-160" data-mp="2t6kuly1ezso2">
          <div className="grid lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)]" data-id="element-161" data-mp="2y67888l5naxe">
            <div className="flex items-center justify-center bg-cream px-6 py-7 sm:p-10" data-id="element-162" data-mp="12plb0riwr98r">
              <img src={BUNDLE_IMAGE_URL} alt="Mockup oficial del libro Postres que Venden™" loading="lazy" decoding="async" width={1254} height={1254} className="h-auto w-full max-w-[260px] object-contain drop-shadow-[0_26px_34px_rgba(56,37,34,0.22)] sm:max-w-[340px]" data-id="element-163" data-mp="xvh58bldp799" />
            </div>

            <div className="p-6 sm:p-9" data-id="element-164" data-mp="1glgo2gqmlq48">
              <p className="font-display text-[1.3rem] font-extrabold uppercase leading-none tracking-tight text-charcoal sm:text-[1.7rem]" data-id="element-165" data-mp="1ckwqjc254khk">
                Postres que Venden™
              </p>

              <p className="mt-4 font-display text-[0.64rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-166" data-mp="16t02furheh9">
                Ebook principal
              </p>
              <ul className="mt-2.5 space-y-1.5" data-id="element-167" data-mp="3sf6qqux0i6cs">
                {OFFER_INCLUDES.map(item => <li key={item} className="flex gap-2.5 font-sans text-[0.85rem] leading-snug text-charcoal/85" data-id="element-168" data-mp="2nol7w6cojoy">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-169" data-mp="3kt1ohrrim965" />
                    {item}
                  </li>)}
              </ul>

              <p className="mt-5 font-display text-[0.64rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-170" data-mp="3b26z4eiz2tgh">
                + Los 5 bonos incluidos
              </p>
              <ul className="mt-2.5 space-y-1.5" data-id="element-171" data-mp="316dcu3fgblli">
                {BONOS.map(bono => <li key={bono.num} className="flex gap-2.5 font-sans text-[0.85rem] font-medium leading-snug text-charcoal/85" data-id="element-172" data-mp="363n8w1xcivib">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-173" data-mp="2x408njgcrvqu" />
                    {bono.name}
                  </li>)}
              </ul>

              <PriceBlock className="mt-7" size="lg" data-id="element-174" data-mp="28jdrjcyqyk0t" />

              <div className="mt-5 flex justify-center" data-id="element-175" data-mp="28kylb0d8lyxm">
                <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-176" data-mp="2mjoe43t0xcg6" />
              </div>

              <p className="mt-3.5 text-center font-sans text-[0.76rem] font-semibold text-taupe" data-id="element-177" data-mp="2igs3az9q6kms">
                Compra única · Acceso digital inmediato
              </p>
              <p className="mt-1.5 text-center font-sans text-[0.72rem] text-taupe/80" data-id="element-178" data-mp="2rhpxyqy9xfsp">
                🔒 Pago seguro · Mercado Pago · Tarjetas de crédito
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}